import {
	usePermissions, useNotify, useRedirect, useTranslate,
	TopToolbar, ListButton, Show, SimpleShowLayout, TextField
} from 'react-admin';
import { Helmet } from 'react-helmet-async';

const CustomActions = () => (
	<TopToolbar>
		<ListButton />
	</TopToolbar>
);

export const UserShow = () => {
	const translate = useTranslate();
	const { permissions, isLoading } = usePermissions();
	const notify = useNotify();
	const redirect = useRedirect();
	
	const pageTitle = translate('resources.user.show');
	const systemName = translate('system.name');
	
	if (isLoading) return null;
	
	if (permissions !== 'user') {
		notify('この機能にアクセスする権限がありません', { type: 'warning' });
		redirect('/user');
		return null;
	}
	
	return (
		<>
			<Helmet>
				<title>{`${pageTitle} | ${systemName}`}</title>
			</Helmet>
			<Show actions={<CustomActions />} title={pageTitle}>
				<SimpleShowLayout>
					<TextField source="id" />
					<TextField source="name" />
				</SimpleShowLayout>
			</Show>
		</>
	);
};

export default UserShow;
